(function () {
  'use strict';

  function iconPlay() {
    return '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M8 6L26 16L8 26V6Z" fill="currentColor"/></svg>';
  }

  function iconPause() {
    return '<svg viewBox="0 0 32 32" fill="none" aria-hidden="true"><rect x="7" y="5" width="5" height="22" rx="1" fill="currentColor"/><rect x="20" y="5" width="5" height="22" rx="1" fill="currentColor"/></svg>';
  }

  function iconMute() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 9H7L12 4V20L7 15H3V9Z" fill="currentColor"/><line x1="16" y1="9" x2="21" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="21" y1="9" x2="16" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  function iconUnmute() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 9H7L12 4V20L7 15H3V9Z" fill="currentColor"/><path d="M16 12C16 10.4 16.8 9 18 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M19.5 6C21.5 7.5 23 9.6 23 12C23 14.4 21.5 16.5 19.5 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  function iconExpand() {
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 9V3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 9V3H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M3 15V21H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 15V21H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function labelsFromRoot(root) {
    return {
      play: root.dataset.labelPlay || 'Play video',
      pause: root.dataset.labelPause || 'Pause video',
      mute: root.dataset.labelMute || 'Mute video',
      unmute: root.dataset.labelUnmute || 'Unmute video',
    };
  }

  function youtubePostMessage(iframe, func, args) {
    if (!iframe?.contentWindow) return;
    const payload =
      args !== undefined
        ? '{"event":"command","func":"' + func + '","args":' + JSON.stringify(args) + '}'
        : '{"event":"command","func":"' + func + '","args":""}';
    iframe.contentWindow.postMessage(payload, '*');
  }

  function initYouTubeRoot(root) {
    const iframe = root.querySelector('.js-youtube');
    const playBtn = root.querySelector('.ls-video__play');
    const toggleBtns = root.querySelectorAll('[data-ls-video-toggle]');
    const muteBtn = root.querySelector('[data-ls-video-mute]');
    const expandBtn = root.querySelector('[data-ls-video-expand]');
    const youtubeId = root.dataset.youtubeId;
    const youtubeParams = root.dataset.youtubeParams;
    const autoplay = root.dataset.youtubeAutoplay === 'true';
    const labels = labelsFromRoot(root);

    if (!iframe || !youtubeId) return;

    let isPlaying = autoplay;
    let isMuted = true;
    let embedLoaded = autoplay;

    function embedSrc(withAutoplay) {
      const ap = withAutoplay ? '&autoplay=1' : '';
      return 'https://www.youtube.com/embed/' + youtubeId + '?' + youtubeParams + ap;
    }

    function loadEmbed(withAutoplay) {
      if (!iframe.getAttribute('src')) {
        iframe.src = embedSrc(withAutoplay);
        embedLoaded = true;
      }
      root.classList.add('ls-video--youtube-active');
    }

    function syncPlayButton() {
      if (playBtn) {
        playBtn.classList.toggle('ls-video__play--playing', isPlaying);
        playBtn.innerHTML = isPlaying ? iconPause() : iconPlay();
        playBtn.setAttribute('aria-label', isPlaying ? labels.pause : labels.play);
      }
      toggleBtns.forEach(function (button) {
        button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      });
    }

    function syncMuteButton() {
      if (!muteBtn) return;
      muteBtn.innerHTML = isMuted ? iconMute() : iconUnmute();
      muteBtn.setAttribute('aria-label', isMuted ? labels.unmute : labels.mute);
    }

    function togglePlay() {
      if (!embedLoaded) {
        loadEmbed(true);
        isPlaying = true;
        syncPlayButton();
        return;
      }
      if (isPlaying) {
        youtubePostMessage(iframe, 'pauseVideo');
        isPlaying = false;
      } else {
        youtubePostMessage(iframe, 'playVideo');
        isPlaying = true;
      }
      syncPlayButton();
    }

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        togglePlay();
      });
    }

    toggleBtns.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.stopPropagation();
        togglePlay();
      });
    });

    root.querySelector('.ls-video__frame')?.addEventListener('click', function (e) {
      if (
        e.target.closest(
          '.ls-video__play, .ls-video__ctrl, [data-ls-video-toggle], [data-ls-video-mute], [data-ls-video-expand]'
        )
      )
        return;
      togglePlay();
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!embedLoaded) {
          loadEmbed(true);
          isPlaying = true;
          syncPlayButton();
        }
        isMuted = !isMuted;
        youtubePostMessage(iframe, isMuted ? 'mute' : 'unMute');
        syncMuteButton();
      });
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        const frame = root.querySelector('.ls-video__frame');
        if (!frame) return;
        const doc = document;
        if (!doc.fullscreenElement) {
          frame.requestFullscreen?.().catch(function () {});
        } else {
          doc.exitFullscreen?.().catch(function () {});
        }
      });
    }

    syncPlayButton();
    syncMuteButton();

    if (autoplay) {
      loadEmbed(true);
      isPlaying = true;
      syncPlayButton();
    }
  }

  function initVideoRoot(root) {
    const video = root.querySelector('video');
    const playBtn = root.querySelector('.ls-video__play');
    const toggleBtns = root.querySelectorAll('[data-ls-video-toggle]');
    const muteBtn = root.querySelector('[data-ls-video-mute]');
    const expandBtn = root.querySelector('[data-ls-video-expand]');
    const labels = labelsFromRoot(root);

    if (!video) return;

    function syncPlayButton() {
      const isPlaying = !video.paused && !video.ended;
      if (playBtn) {
        playBtn.classList.toggle('ls-video__play--playing', isPlaying);
        playBtn.innerHTML = isPlaying ? iconPause() : iconPlay();
        playBtn.setAttribute('aria-label', isPlaying ? labels.pause : labels.play);
      }
      toggleBtns.forEach(function (button) {
        button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      });
    }

    function syncMuteButton() {
      if (!muteBtn) return;
      muteBtn.innerHTML = video.muted ? iconMute() : iconUnmute();
      muteBtn.setAttribute('aria-label', video.muted ? labels.unmute : labels.mute);
    }

    function togglePlay() {
      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
      syncPlayButton();
    }

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        togglePlay();
      });
    }

    toggleBtns.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.stopPropagation();
        togglePlay();
      });
    });

    root.querySelector('.ls-video__frame')?.addEventListener('click', function (e) {
      if (
        e.target.closest(
          '.ls-video__play, .ls-video__ctrl, [data-ls-video-toggle], [data-ls-video-mute], [data-ls-video-expand]'
        )
      )
        return;
      togglePlay();
    });

    video.addEventListener('play', syncPlayButton);
    video.addEventListener('pause', syncPlayButton);
    video.addEventListener('ended', syncPlayButton);

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        syncMuteButton();
      });
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        const frame = root.querySelector('.ls-video__frame');
        if (!frame) return;
        const doc = document;
        if (!doc.fullscreenElement) {
          frame.requestFullscreen?.().catch(function () {});
        } else {
          doc.exitFullscreen?.().catch(function () {});
        }
      });
    }

    video.muted = true;
    if (video.autoplay) {
      video.play().catch(function () {});
    }
    syncPlayButton();
    syncMuteButton();
  }

  function initRoot(root) {
    if (root.dataset.lsVideoInitialized === 'true') return;
    root.dataset.lsVideoInitialized = 'true';

    if (root.classList.contains('ls-video--youtube-native')) return;

    if (root.hasAttribute('data-ls-video-youtube')) {
      initYouTubeRoot(root);
      return;
    }

    initVideoRoot(root);
  }

  function initAll() {
    document.querySelectorAll('[data-ls-video-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const roots = event.target.querySelectorAll?.('[data-ls-video-root]');
    if (roots && roots.length) {
      roots.forEach(initRoot);
    }
  });
})();
